import React, { Component, useRef, useEffect, useMemo } from 'react';
import { Card, CardBody, CardTitle, CardFooter, Row, Button } from 'reactstrap';
import { connect } from 'react-redux';
import {
    setContainerClassnames,
    clickOnMobileMenu,
} from '../../../redux/actions';
import { Colxx } from '../../../components/common/CustomBootstrap';
import classnames from 'classnames';
import QRCodeStyling from 'qr-code-styling';
import { NotificatioErrController } from '../../../helpers/Utils';
import { buildPublicMenuUrl } from '../../../helpers/PublicMenuUrl';

const QR_POSTER_CONFIG = {
    width: 900,
    height: 1580,
    outerMargin: 22,
    innerMargin: 46,
    borderRadius: 52,
    borderColor: '#e0362e',
    panelColor: '#efefef',
    titleColor: '#5b5b5b',
    bodyTextColor: '#5a5a5a',
    subTextColor: '#6d6d6d',
    qrSize: 570,
};

const drawRoundedRect = (ctx, x, y, width, height, radius) => {
    const r = Math.min(radius, width / 2, height / 2);

    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + width, y, x + width, y + height, r);
    ctx.arcTo(x + width, y + height, x, y + height, r);
    ctx.arcTo(x, y + height, x, y, r);
    ctx.arcTo(x, y, x + width, y, r);
    ctx.closePath();
};

const normalizeCompanyField = (value, fallbackText) => {
    const normalized = String(value || '').trim();

    if (
        !normalized ||
        normalized.toLowerCase() === 'null' ||
        normalized.toLowerCase() === 'undefined'
    ) {
        return fallbackText;
    }

    return normalized;
};

const splitTextByWidth = (ctx, text, maxWidth, maxLines = 2) => {
    const normalized = String(text || '').trim();
    if (!normalized) return [];

    const words = normalized.split(/\s+/);
    let lines = [];
    let currentLine = words[0] || '';

    for (let i = 1; i < words.length; i += 1) {
        const nextLine = `${currentLine} ${words[i]}`;

        if (ctx.measureText(nextLine).width <= maxWidth) {
            currentLine = nextLine;
        } else {
            lines.push(currentLine);
            currentLine = words[i];
        }
    }

    lines.push(currentLine);

    if (lines.length <= maxLines) {
        return lines;
    }

    const fixedLines = lines.slice(0, maxLines - 1);
    let lastLine = lines.slice(maxLines - 1).join(' ');

    while (lastLine.length > 0) {
        const textWithEllipsis = `${lastLine}...`;
        if (ctx.measureText(textWithEllipsis).width <= maxWidth) {
            fixedLines.push(textWithEllipsis);
            return fixedLines;
        }
        lastLine = lastLine.slice(0, -1).trim();
    }

    fixedLines.push('...');
    return fixedLines;
};

const loadImageFromBlob = (blob) =>
    new Promise((resolve, reject) => {
        const url = URL.createObjectURL(blob);
        const img = new Image();

        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img);
        };
        img.onerror = (error) => {
            URL.revokeObjectURL(url);
            reject(error);
        };
        img.src = url;
    });

const canvasToBlob = (canvas) =>
    new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (!blob) {
                    reject(new Error('Không thể tạo ảnh từ canvas.'));
                    return;
                }
                resolve(blob);
            },
            'image/png',
            1
        );
    });

const triggerDownload = (blob, filename) => {
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.download = filename;
    const supportsDownload = typeof link.download === 'string';

    if (supportsDownload) {
        document.body.appendChild(link);
        link.click();
        link.remove();
    } else {
        window.open(url, '_blank');
    }

    window.setTimeout(() => {
        URL.revokeObjectURL(url);
    }, 1000);
};

class LabelItemLeft extends Component {
    // componentDidMount() {
    //     qrCode.append(this.props.ref.current);
    //   }

    menuButtonClick = (e, menuClickCount, containerClassnames) => {
        setTimeout(() => {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('resize', false, false);
            window.dispatchEvent(event);
        }, 350);
        this.props.setContainerClassnames(
            menuClickCount,
            containerClassnames,
            this.props.selectedMenuHasSubItems
        );
    };

    onClickedItem = (floor) => {
        this.props.onClickedItem(
            // callback
            floor,
            this.menuButtonClick,
            [null, 1000, this.props.containerClassnames]
        );
    };

    render() {
        const { data, isDisableDownload } = this.props;

        return (
            data &&
            data.map((floor, floor_idx) => (
                <Row
                    onClick={() => {
                        this.onClickedItem(floor);
                    }}
                    key={floor_idx}
                    className='mb-4'
                >
                    <Colxx xxs='12'>
                        {/* {
                            <Button
                                className='mb-4'
                                color='primary'
                                onClick={() =>
                                    generateQR(
                                        'thanhpq7.localhost:8080/menu/zacij3n60ebpvura69ncznq9cvhth45a0rzm-1'
                                    )
                                }
                            >
                                Tạo mã qrCode
                            </Button>
                        }
                        <div>
                          <img id="qrcode" alt="QR Code" />
                        </div> */}
                        <Card>
                            <CardBody>
                                <div
                                    onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();

                                        this.props.exportFloor(
                                            floor.floor,
                                            floor.data.map(
                                                (_hash) =>
                                                    _hash.u +
                                                    '-' +
                                                    _hash.identify
                                            )
                                        );
                                    }}
                                    className={classnames(
                                        'position-absolute card-top-buttons custom-inline',
                                        {
                                            disable: isDisableDownload,
                                        }
                                    )}
                                >
                                    <Button size='sm' color='primary'>
                                        Tải tất cả
                                    </Button>
                                </div>
                                <CardTitle>{`Khu ${floor.floor}`}</CardTitle>
                                <Row>
                                    {floor.data.map((table, table_idx) => (
                                        <Colxx
                                            key={table_idx}
                                            xxs='6'
                                            xs='6'
                                            sm='6'
                                            md='4'
                                            lg='3'
                                        >
                                            <ItemRender
                                                u={table.u}
                                                identify={table.identify}
                                            />
                                        </Colxx>
                                    ))}
                                </Row>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
            ))
        );
    }
}

const ItemRender = ({ identify, u }) => {
    const ref = useRef(null);
    const tableName = `Bàn ${identify}`;
    const storeName = normalizeCompanyField(
        localStorage.getItem('companyName'),
        'VMASS'
    );
    const storeAddress = normalizeCompanyField(
        localStorage.getItem('companyAddress'),
        'Đang cập nhật địa chỉ'
    );
    const storeHotline = normalizeCompanyField(
        localStorage.getItem('hotline'),
        'Đang cập nhật số điện thoại'
    );
    const text = buildPublicMenuUrl(u);
    const qrCode = useMemo(
        () =>
            new QRCodeStyling({
                data: text,
                width: 250,
                height: 250,
                image: '',
                qrOptions: {
                    typeNumber: '8',
                    mode: 'Byte',
                    errorCorrectionLevel: 'Q',
                },
                dotsOptions: {
                    color: '#f00',
                    type: 'dots',
                },
                imageOptions: {
                    crossOrigin: 'anonymous',
                    margin: 20,
                },
                backgroundOptions: {
                    color: 'rgba(0,0,0,0)',
                },
                cornersSquareOptions: {
                    type: '',
                    color: '#ff0000',
                    gradient: {
                        type: 'linear',
                        rotation: 0,
                        colorStops: [
                            { offset: 0, color: '#ff2424' },
                            { offset: 1, color: '#9b0303' },
                        ],
                    },
                },
            }),
        [text]
    );

    useEffect(() => {
        const wrapper = ref.current;
        if (!wrapper) return undefined;

        wrapper.innerHTML = '';
        qrCode.append(wrapper);

        return () => {
            wrapper.innerHTML = '';
        };
    }, [qrCode]);

    const onDownloadClick = async (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        try {
            const qrRawData = await qrCode.getRawData('png');
            const qrImage = await loadImageFromBlob(qrRawData);

            const {
                width,
                height,
                outerMargin,
                innerMargin,
                borderRadius,
                borderColor,
                panelColor,
                titleColor,
                bodyTextColor,
                subTextColor,
                qrSize,
            } = QR_POSTER_CONFIG;

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');

            if (!ctx) {
                throw new Error('Không khởi tạo được canvas để tạo poster QR.');
            }

            // White outer background.
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, width, height);

            // Red rounded frame.
            drawRoundedRect(
                ctx,
                outerMargin,
                outerMargin,
                width - outerMargin * 2,
                height - outerMargin * 2,
                borderRadius
            );
            ctx.fillStyle = borderColor;
            ctx.fill();

            // Light gray inner panel.
            drawRoundedRect(
                ctx,
                innerMargin,
                innerMargin,
                width - innerMargin * 2,
                height - innerMargin * 2,
                borderRadius - 14
            );
            ctx.fillStyle = panelColor;
            ctx.fill();

            // Header text.
            ctx.textAlign = 'center';
            ctx.fillStyle = titleColor;
            ctx.font = "600 66px 'Nunito', 'Segoe UI', sans-serif";
            ctx.fillText('Quét mã QR', width / 2, 210);
            ctx.font = "500 58px 'Nunito', 'Segoe UI', sans-serif";
            ctx.fillText('để xem menu | gọi món', width / 2, 290);

            // QR area.
            const qrX = (width - qrSize) / 2;
            const qrY = 360;
            ctx.fillStyle = panelColor;
            ctx.fillRect(qrX - 16, qrY - 16, qrSize + 32, qrSize + 32);
            ctx.drawImage(qrImage, qrX, qrY, qrSize, qrSize);

            // Store information right below QR.
            const storeInfoTopY = qrY + qrSize + 78;
            const infoMaxWidth = width - 170;

            ctx.fillStyle = titleColor;
            ctx.font = "700 42px 'Nunito', 'Segoe UI', sans-serif";
            ctx.fillText(storeName, width / 2, storeInfoTopY, infoMaxWidth);

            ctx.fillStyle = bodyTextColor;
            ctx.font = "500 31px 'Nunito', 'Segoe UI', sans-serif";
            const addressLines = splitTextByWidth(
                ctx,
                storeAddress,
                infoMaxWidth,
                2
            );
            const addressStartY = storeInfoTopY + 52;
            addressLines.forEach((line, lineIndex) => {
                ctx.fillText(line, width / 2, addressStartY + lineIndex * 40);
            });

            const phoneY = addressStartY + addressLines.length * 40 + 44;
            ctx.fillStyle = bodyTextColor;
            ctx.font = "600 32px 'Nunito', 'Segoe UI', sans-serif";
            ctx.fillText(`SĐT: ${storeHotline}`, width / 2, phoneY, infoMaxWidth);

            // Table line + text block.
            const dividerY = phoneY + 80;
            ctx.strokeStyle = '#888888';
            ctx.lineWidth = 3;
            ctx.beginPath();
            ctx.moveTo(140, dividerY);
            ctx.lineTo(width / 2 - 120, dividerY);
            ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(width / 2 + 120, dividerY);
            ctx.lineTo(width - 140, dividerY);
            ctx.stroke();

            ctx.fillStyle = borderColor;
            ctx.beginPath();
            ctx.arc(width / 2, dividerY, 54, 0, Math.PI * 2);
            ctx.fill();

            ctx.fillStyle = '#ffffff';
            ctx.font = "700 38px 'Nunito', 'Segoe UI', sans-serif";
            ctx.fillText(tableName, width / 2, dividerY + 14);

            // Footer text.
            ctx.fillStyle = bodyTextColor;
            ctx.font = "500 36px 'Nunito', 'Segoe UI', sans-serif";
            ctx.fillText('Mở Camera hoặc Zalo để quét mã', width / 2, 1450);
            ctx.fillStyle = subTextColor;
            ctx.font = "500 34px 'Nunito', 'Segoe UI', sans-serif";
            ctx.fillText('Bản quyền thuộc vmass.vn', width / 2, 1502);

            const posterBlob = await canvasToBlob(canvas);
            triggerDownload(posterBlob, `ban-${identify}-poster.png`);
        } catch (error) {
            console.error(error);
            // Fallback to original QR download if poster render fails.
            qrCode.download({
                name: `ban-${identify}`,
                extension: 'png',
            });
            NotificatioErrController(
                'Không thể tạo poster QR theo mẫu, đã tải file QR cơ bản.'
            );
        }
    };

    return (
        <Card className='mb-4'>
            <div className='qrcode-wrapper mt-3 mb-2' ref={ref}>
                {/* <img
                    src={`${END_POINT_QRCODE}/qrcode?text=${identify}&data=${
                        window.location.protocol
                    }//${window.location.host + '/menu/' + u}`}
                /> */}
                {/* <h6 className='text-center'>Quét mã để gọi món!</h6> */}
            </div>
            <CardFooter>
                <span>{`Bàn ${identify}`}</span>
                <div className='position-absolute card-bottom-buttons custom-inline'>
                    <span
                        className='cursor-pointer'
                        onClick={onDownloadClick}
                        role='button'
                        tabIndex={0}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                onDownloadClick(event);
                            }
                        }}
                    >
                        <i className='simple-icon-cloud-download' />
                    </span>
                </div>
            </CardFooter>
        </Card>
    );
};

const mapStateToProps = ({ menu }) => {
    const { containerClassnames, menuClickCount, selectedMenuHasSubItems } =
        menu;
    return {
        containerClassnames,
        menuClickCount,
        selectedMenuHasSubItems,
    };
};
export default connect(mapStateToProps, {
    setContainerClassnames,
    clickOnMobileMenu,
})(LabelItemLeft);
